import { faLocationDot } from "@fortawesome/pro-solid-svg-icons/faLocationDot";
import { faStar } from "@fortawesome/pro-solid-svg-icons/faStar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Box from "@mui/material/Box";
import Typography, { TypographyProps } from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import { Testimonial } from "../../utils/resultsHelpers";

export const DreamSearchStudentTestimonialItem = ({ text, name, city, state }: Testimonial) => (
  <TestimonialCard>
    <TestimonialTop>
      {/* Promo copy on a card injected mid-results, not a section heading — styling unchanged. */}
      <TestimonialTitle variant="new_h3" component="p">
        Start your journey to a new career
      </TestimonialTitle>
      <TestimonialBody>&ldquo;{text}&rdquo;</TestimonialBody>
      <TestimonialStars>
        {Array(5)
          .fill(null)
          .map((_, index) => (
            <FontAwesomeIcon key={index} icon={faStar} />
          ))}
      </TestimonialStars>
    </TestimonialTop>
    <TestimonialBottom>
      <TestimonialName>{name}</TestimonialName>
      <TestimonialLocation>
        <FontAwesomeIcon className="location_dot" icon={faLocationDot} /> {city}, {state}
      </TestimonialLocation>
    </TestimonialBottom>
  </TestimonialCard>
);

const TestimonialCard = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 0.5rem;
`;
const TestimonialTop = styled(Box)`
  flex-grow: 1;
  text-align: center;
`;
const TestimonialBottom = styled(Box)`
  height: 5rem;
  display: flex;
  text-align: center;
  justify-content: center;
  flex-direction: column;
`;
const TestimonialTitle = styled(Typography)<TypographyProps>`
  font-size: 1.5rem;
`;
const TestimonialBody = styled(Typography)`
  font-size: 1.2rem;
  font-style: italic;
  margin-bottom: 1rem;
`;
const TestimonialStars = styled(Box)`
  display: flex;
  gap: 0.5rem;
  justify-content: center;
`;
const TestimonialName = styled(Typography)`
  font-weight: bold;
`;
const TestimonialLocation = styled(Typography)`
  .location_dot {
    margin-right: 0.25rem;
  }
`;
